<template>
  <fieldset class="relative">
    <legend>Consignment Note #{{ index + 1 }}</legend>

    <ladda-button v-if="canDelete"  :on-click="handleDeleteDocket" type="danger" class="btn-circle btn-remove-docket">
      <i class="fa fa-trash"></i>
    </ladda-button>

    <div class="row">
      <div class="col-sm-6">
        <div class="form-group-outer">
          <div class="form-group float-label-control float-label-no-animation">
            <label for="" class="select-label">File Name</label>
            <input type="text" class="form-control" v-model="name" :disabled="disabled">
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div :class="{ 'col-sm-6 col-md-8': notDisabled, 'col-sm-12': disabled }">
        <div class="form-group float-label-control float-label-no-animation">
          <label for="" class="select-label">File</label>
          <input type="text" class="form-control" :value="file" disabled>
        </div>
      </div>
      <div class="col-sm-6 col-md-4" v-if="notDisabled">
        <label class="btn btn-primary btn-sm btn-block m-b-md" :for="`docket-${identifiers.index}`">
          <input type="file" class="sr-only" name="file" :id="`docket-${identifiers.index}`" accept=".jpg,.jpeg,.png,.gif" @change="handleFileSelection">
          Select File
        </label>
      </div>
    </div>
  </fieldset>
</template>

<script>
  import { LaddaButton } from 'components/forms'
  import { SET_DOCKET_ATTRIBUTE, REMOVE_DOCKET } from 'vx/mutations'
  import { mapMutations } from 'vuex'
  import { docketStateMapper, docketActionsHelpers } from 'mixins/weighbridge'
  import { jobHelpers } from 'mixins/jobs'

  export default {
    props: ['docket', 'index'],

    mixins: [docketStateMapper, docketActionsHelpers, jobHelpers],

    components: {
      LaddaButton
    },

    computed: {
      identifiers () {
        return { index: this.docket.index, id: this.docket.id }
      },

      canDelete () {
        return this.jobIsEditable && (this.docket.id === null || this.$user.isAdminOrCoordinator)
      },

      disabled () {
        if (this.jobIsNotEditable) {
          return true
        }

        if (this.docket.id === null || this.$user.isAdmin || this.docket.status === 'resubmit') {
          return false
        }

        return true
      },

      notDisabled () {
        return this.disabled === false
      }
    },

    methods: {
      ...mapMutations('weighbridge', [SET_DOCKET_ATTRIBUTE, REMOVE_DOCKET])
    }
  }
</script>



// WEBPACK FOOTER //
// WeighbridgeConsignmentItem.vue?4f7a7441